import React from 'react'
import { Row, Col, Nav, Navbar, Container, Image } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa'

import logo from '../assets/img/logos/logo_new.png'

import '../styles/footer.styles.scss'

const Footer = () => {
    return (
        <footer fixed="bottom" className="footer">
            <Container>
                <Row className="footer__main mx-0">
                    <Col lg={5} md={12} className="footer__column footer__about">
                        <p className="footer__intro">La Vida en Rojo es una asociaci&oacute;n feminista independiente dedicada a la cultura menstrual.</p>
                        <p className="footer__statement">Nuestra autonom&iacute;a no est&aacute; en venta: no colaboramos con empresas cuya perspectiva responda a l&oacute;gicas higienistas, capitalistas, colonialistas, racistas o intervencionistas, ni aceptamos v&iacute;nculos que comprometan nuestra integridad o contradigan los principios &eacute;ticos que nos gu&iacute;an.</p>
                        <p className="footer__legal">La asociaci&oacute;n fue inscrita en la Secci&oacute;n 1&ordf; del Registro de Asociaciones de la Generalitat de Catalu&ntilde;a con fecha 29 de marzo de 2021. NIF: G05361753</p>
                    </Col>

                    <Col lg={2} md={4} sm={6} className="footer__column">
                        <h4 className="footer__heading">NAVEGACI&Oacute;N</h4>
                        <Nav className="footer__nav">
                            <LinkContainer to="/asociacion">
                                <Nav.Link>Asociaci&oacute;n</Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/que-hacemos">
                                <Nav.Link>Qu&eacute; hacemos</Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/publicaciones">
                                <Nav.Link>Publicaciones</Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/memorias">
                                <Nav.Link>Memorias</Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/hazte-amiga">
                                <Nav.Link>Hazte amiga</Nav.Link>
                            </LinkContainer>
                        </Nav>
                    </Col>

                    <Col lg={2} md={4} sm={6} className="footer__column">
                        <h4 className="footer__heading">SOCIALIZA</h4>
                        <div className="footer__social-icons">
                            <Nav.Link
                                href="https://www.instagram.com/lavidaenrojo_asociacion/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                            >
                                <FaInstagram size={22} />
                            </Nav.Link>
                            <Nav.Link
                                href="https://www.facebook.com/lavidaenrojoasociacion"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                            >
                                <FaFacebook size={22} />
                            </Nav.Link>
                            <Nav.Link
                                href="https://www.youtube.com/@lavidaenrojo_asociacion"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="YouTube"
                            >
                                <FaYoutube size={23} />
                            </Nav.Link>
                        </div>
                    </Col>

                    <Col lg={3} md={4} className="footer__column footer__brand">
                        <div className="footer__contact">
                            <h4 className="footer__heading">CONTACTA</h4>
                            <a className="footer__contact-link" href="mailto:asociacionculturamenstrual@gmail.com">asociacionculturamenstrual@gmail.com</a>
                            <a className="footer__contact-link" href="tel:+34640106130">640 10 61 30</a>
                        </div>
                        <Navbar.Brand href="inicio" className="footer__logo-link">
                            <Image
                                className="logo"
                                alt="La Vida en Rojo"
                                src={logo}
                                width="400"
                            />
                        </Navbar.Brand>
                    </Col>
                </Row>

                <Row className="footer__bottom mx-0">
                    <Col md={5} className="footer__bottom-item">
                        <p>@LAVIDAENROJO.2023 | Todos los derechos reservados</p>
                    </Col>
                    <Col md={7} className="footer__bottom-item footer__bottom-links">
                        <LinkContainer to="/politicaprivacidad">
                            <Nav.Link>Pol&iacute;tica privacidad</Nav.Link>
                        </LinkContainer>
                        <p>Dise&ntilde;o Web: Intellisite</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer
